export const firebaseConfig = {
    apiKey: "AIzaSyBAXl1Xcw9V3pAAlbRhu1Fkpj1TtXwlf6c",
    authDomain: "oracleworlds-992f4.firebaseapp.com",
    databaseURL: "https://oracleworlds-992f4.firebaseio.com",
    projectId: "oracleworlds-992f4",
    storageBucket: "oracleworlds-992f4.appspot.com",
    messagingSenderId: "297021686052",
    appId: "1:297021686052:web:23df2d28ff7681b51db3b1",
    measurementId: "G-658SF9GQ1K"
};